// extracted by mini-css-extract-plugin
module.exports = {"collapsedContainer":"styles_collapsedContainer__cDVdD","container":"styles_container__SgFjz"};